import { render, staticRenderFns } from "./customRating.vue?vue&type=template&id=2c36aa70&"
import script from "./customRating.vue?vue&type=script&lang=js&"
export * from "./customRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports